module.exports = __webpack_public_path__ + "img/2.ae9f11e3.png";